<script setup lang="ts">
import { computed } from 'vue';
import type { RemoteDevice } from '../model.js';
import type { DeviceColor, DeviceIcon } from '../lib/customization.js';
import { deviceIconGlyph } from '../lib/directory.js';
import AppIcon from './AppIcon.vue';
import OsIcon from './OsIcon.vue';
import { operatingSystem } from '../lib/operating-system.js';

/**
 * The device tile: a person's chosen icon and identity colour, with the operating
 * system as a small badge. Presence never colours the tile; it only dims it.
 */
const props = defineProps<{
  icon: DeviceIcon;
  platform: string;
  osVersion?: string | undefined;
  color?: DeviceColor | undefined;
  presence?: RemoteDevice['presence'] | undefined;
  size?: 'sm' | 'md' | 'lg' | undefined;
}>();
const system = computed(() => operatingSystem(props.platform, props.osVersion));
</script>

<template>
  <span
    class="device-glyph"
    :class="props.size ?? 'md'"
    :data-color="props.color ?? 'mint'"
    :data-presence="props.presence"
    :data-platform="props.platform"
  >
    <AppIcon :name="deviceIconGlyph[props.icon]" />
    <span v-if="system" class="os-badge" :title="system.label" aria-hidden="true">
      <OsIcon :platform="props.platform" :version="props.osVersion" />
    </span>
  </span>
</template>
